export default __webpack_public_path__ + "static/media/question-alert.e918eb15.svg";